/**
 * ? @description : This is the private route component which is used to check if the user is authenticated or not
 */

// Dependencies
import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

// Components
import NavBar from "../../NavBar/NavBar";
import { selectUser } from "../../redux/features/userSlice";

function PrivateRoute() {
  const user = useSelector(selectUser);
  

  return user.isAuthenticated ? <NavBar /> : <Navigate to="/login" />;
}

export default PrivateRoute;
